import React from 'react';
import { Button } from '@ver-uds/react';
import { Alert } from '@ver-uds/uswds-react';
import { useHistory } from 'react-router-dom';
import { ClosedReason } from 'eve-account-client';
import TerminationReasonSelection from './TerminationReasonSelection';
import { redirectToUrl } from '../utils/util';

export type TerminationRequestFeedbackProps = {
  terminationAllowed: boolean;
  terminationNotAllowedReason: string | undefined;
  feedbackText: string;
  closedReasons: ClosedReason[] | undefined;
  link?: string;
  linkText?: string;
};
const TerminationRequestFeedback = ({
  terminationAllowed,
  terminationNotAllowedReason,
  feedbackText,
  closedReasons,
  link,
  linkText = 'View Company Profile',
}: TerminationRequestFeedbackProps): JSX.Element => {
  const history = useHistory();
  return (
    <>
      <hr className="margin-top-4 margin-bottom-4" />
      <p className="grid-col-12 tablet:grid-col-9 desktop:grid-col-9">{feedbackText}</p>
      <TerminationReasonSelection closedReasons={closedReasons} noMarginBottom={!terminationAllowed} />
      {!terminationAllowed && (
        <Alert className="margin-top-3 margin-bottom-5" status="info">
          <Alert.Heading>Account termination is not required.</Alert.Heading>
          <Alert.Text>
            <span
              className="display-flex tablet:grid-col-9"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: terminationNotAllowedReason ?? '',
              }}
            />
          </Alert.Text>
        </Alert>
      )}

      <hr className="margin-bottom-1" />
      {terminationAllowed ? (
        <>
          <Button variant="secondary" onClick={() => redirectToUrl(history, link)}>
            Cancel
          </Button>
          <Button type="submit" variant="primary" aria-label="Open screen to review termination request">
            Next
          </Button>
        </>
      ) : (
        <Button variant="primary" onClick={() => redirectToUrl(history, link)}>
          {linkText}
        </Button>
      )}
    </>
  );
};

export default TerminationRequestFeedback;
